import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import { css, cx, ui } from '@wp-g2/styles';
import { is, noop, useControlledState } from '@wp-g2/utils';
import React, { useCallback } from 'react';
import { Radio as ReakitRadio } from 'reakit';
import { useFormGroupContextId } from '../FormGroup';
import { useRadioGroupContext } from '../RadioGroup';
import { RadioDotView, RadioIconView, RadioWrapperView } from './Radio.styles';
import * as styles from './Radio.styles';

function RadioElement(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'RadioElement'),
      checkedProp = _useContextSystem.checked,
      className = _useContextSystem.className,
      cssProp = _useContextSystem.css,
      defaultValue = _useContextSystem.defaultValue,
      idProp = _useContextSystem.id,
      _useContextSystem$onC = _useContextSystem.onChange,
      onChange = _useContextSystem$onC === void 0 ? noop : _useContextSystem$onC,
      otherProps = _objectWithoutProperties(_useContextSystem, ["checked", "className", "css", "defaultValue", "id", "onChange"]);

  var _useRadioGroupContext = useRadioGroupContext(),
      radio = _useRadioGroupContext.radio;

  var id = useFormGroupContextId(idProp);

  var _useControlledState = useControlledState(checkedProp, {
    initial: defaultValue || false
  }),
      _useControlledState2 = _slicedToArray(_useControlledState, 2),
      checked = _useControlledState2[0],
      setChecked = _useControlledState2[1];

  var classes = cx(styles.Radio, [css(cssProp), className]);
  var handleOnChange = useCallback(function (event) {
    var next = event.target.checked;

    if (is.empty(radio)) {
      setChecked(next);
    }

    onChange(next, {
      event: event
    });
  }, [onChange, radio, setChecked]);
  var checkedState = is.empty(radio) ? checked : undefined;
  return /*#__PURE__*/React.createElement(RadioWrapperView, ui.$('RadioWrapper'), /*#__PURE__*/React.createElement(ReakitRadio, Object.assign({
    checked: checkedState
  }, otherProps, radio, {
    className: classes,
    id: id,
    onChange: handleOnChange,
    ref: forwardedRef
  })), /*#__PURE__*/React.createElement(RadioIconView, Object.assign({}, ui.$('RadioIcon'), {
    "aria-hidden": true
  }), /*#__PURE__*/React.createElement(RadioDotView, null)));
}

export default contextConnect(RadioElement, 'RadioElement');